import React from 'react';
import PropTypes from 'prop-types';
import './Dashboard.scss';
import house from './ie.svg';
import DashboardAttribute from './DashboardAttribute';
import FullAddressBuilder from '../../../common/FullAddressBuilder';

const CustomerDetailsTile = (props) => {
  const { customerInfo } = props;
  if (customerInfo.firstName) {
    return (
      <div id="customer_details-tile" className="account-action-tile">
        <img
          src={house}
          alt={'You Account Details'}
        />
        <DashboardAttribute label="Customer Name">
          {customerInfo.firstName} {customerInfo.lastName}
        </DashboardAttribute>
        <DashboardAttribute label="Current Plan">
          {customerInfo.currentPlan}
        </DashboardAttribute>
        {customerInfo.streetName &&
        <DashboardAttribute label="Customer Address" hasMultiLineValue>
          {FullAddressBuilder.buildMultiLine(customerInfo)}
        </DashboardAttribute>
        }
        <DashboardAttribute label="Email">
          {customerInfo.emailAddress}
        </DashboardAttribute>
        <DashboardAttribute label="Contact Number">
          {customerInfo.mobileNumber}
        </DashboardAttribute>
      </div>
    );
  }
  return null;
};

CustomerDetailsTile.propTypes = {
  customerInfo: PropTypes.object.isRequired
};

export default CustomerDetailsTile;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/Dashboard/CustomerDetailsTile.js
 **/